function UserGreeting(props) {
  console.log("test");
  return <h1>Welcome back!</h1>;
}

export default UserGreeting;
